export default {"src":"/_next/static/media/MARA.4a8df5bc.svg","height":18,"width":18};